import { render } from "./StudentUserAdd.vue?vue&type=template&id=67a52d74&scoped=true"
import script from "./StudentUserAdd.vue?vue&type=script&lang=js"
export * from "./StudentUserAdd.vue?vue&type=script&lang=js"

import "./StudentUserAdd.vue?vue&type=style&index=0&id=67a52d74&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a52d74"]])

export default __exports__